import React from 'react'
import TopSideBar from '../../components/TopSideBar'
import CompaniesListing from '../../components/CompaniesListing'
import { useProject } from '../../context/ProjectContext';

export default function CompaniesListingPage({ setBlockScreen }: any) {
  const { isProjectUndefined } = useProject();

  return <>
    <TopSideBar currentSection='companies' />

    {!isProjectUndefined() && (
      <CompaniesListing
        setBlockScreen={setBlockScreen}
      />
    )}
  </>

}